// auth
export const SET_BEARER = 'SET_BEARER'
export const SET_CLIENTS = 'SET_CLIENTS'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_TOKEN_RESET_PASSWORD = 'SET_TOKEN_RESET_PASSWORD'
export const PASSWORD_CHANGED = 'PASSWORD_CHANGED'

// app
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const SET_WARNING = 'SET_WARNING'
export const SET_OK = 'SET_OK'
export const SET_BANNED = 'SET_BANNED'
export const SET_SEIZED = 'SET_SEIZED'
export const SET_UNBANNED = 'SET_UNBANNED'
export const SET_RESET = 'SET_RESET'
export const SET_SEARCH = 'SET_SEARCH'
export const SET_USERNAME = 'SET_USERNAME'
export const SET_ADD = 'SET_ADD'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
export const SET_CLIENT_ID = 'SET_CLIENT_ID'
export const SET_SELECTED_CLIENT = 'SET_SELECTED_CLIENT'
export const SET_SERVER_NAME = 'SET_SERVER_NAME'
export const SET_COPY = 'SET_COPY'
export const SET_MENU_SELECT = 'SET_MENU_SELECT'

// tags
export const FETCH_TAGS = 'FETCH_TAGS'
export const FETCH_TAG = 'FETCH_TAG'

// Affiliates
export const FETCH_AFFILIATES = 'FETCH_AFFILIATES'
export const FETCH_AFFILIATE = 'FETCH_AFFILIATE'
export const CLEAR_AFFILIATE = 'CLEAR_AFFILIATE'
export const CLEAR_AFFILIATES = 'CLEAR_AFFILIATES'
export const SET_STATE = 'SET_STATE'
export const SAVE_TAGS = 'SAVE_TAGS'
export const FETCH_NETWORK = 'FETCH_NETWORK'
export const SET_TOP = 'SET_TOP'
export const FETCH_CHECK = 'FETCH_CHECK'
export const SELECT_AFFILIATE = 'SELECT_AFFILIATE'
export const SAVE_AFFILIATES = 'SAVE_AFFILIATES'
export const SELECT_AFFILIATE_DATA = 'SELECT_AFFILIATE_DATA'
export const SEARCH_AFFILIATE = 'SEARCH_AFFILIATE'
export const FETCH_SEARCH_AFFILIATES = 'FETCH_SEARCH_AFFILIATES'
export const CATEGORIES_AFFILIATES = 'CATEGORIES_AFFILIATES'

// Providers
export const FETCH_PROVIDERS = 'FETCH_PROVIDERS'

// Products
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_SAVEPRODUCT = 'FETCH_SAVEPRODUCT'
export const SET_ACTIVE = 'SET_ACTIVE'
export const SELECT_PRODUCT = 'SELECT_PRODUCT'
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES'

// Product catalog
export const SET_PRODUCT_CATALOG_STATE = 'SET_PRODUCT_CATALOG_STATE'

// header
export const SET_MODAL_BRAND = 'SET_MODAL_BRAND'
